import dayjs from 'dayjs'

/**
 * @param d
 * @param format
 */
function datetime (d, format = 'YYYY-MM-DD HH:MM') {
  const dd = dayjs(d)

  if (!dd.isValid()) {
    return dd
  }

  return dd.format(format)
}

/**
 * @param html
 * @return {string | string}
 */
function stripHtml (html) {
  const tmp = document.implementation.createHTMLDocument('New').body
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ''
}

// TODO
export {
  datetime,
  stripHtml
}
